// extracted by mini-css-extract-plugin
export default {"RegenerateButton":"kYWJK8qAqlzoLJNfRHOl","RegenerateButtonContainer":"PGIAHN7QSAdqnaprO9f4"};